import * as bus from "@sinch/bus";
import { EVENT_NAME } from "../analytics/rudderstack/createRudderstackEvent";
import { useNavigationEffect } from "../navigationConfig/useNavigationEffect";
import { APP_NAME } from "../portals/constants";

type UsePageViewEventGenerator = (isListenerSet: boolean) => void;

// Outside of the hook to persist between renders
let lastSentEventPath: string | null = null;

export const usePageViewEventGenerator: UsePageViewEventGenerator = (
  isListenerSet
) => {
  useNavigationEffect(() => {
    if (isListenerSet && lastSentEventPath !== location.pathname) {
      lastSentEventPath = location.pathname;
      bus.sendTrackEvent({
        name: EVENT_NAME.PAGE_LOADED,
        appName: APP_NAME.toLowerCase(),
        purposes: ["Analytical"],
      });
    }
  }, [isListenerSet]);
};
